<template>
  <div class="item-bg">
    <div class="item-img">
      <img
        :src="itemObj.thumb_path"
        alt="img"
        :style="{border:  selected.includes(itemObj) ? '2px #015c61 solid'  : '' }"
      />
      <div class="item-title">{{itemObj.scene_title}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemObj: {
      type: Object,
      required: true,
    },
    selected: {
      type: Array,
      default: () => [],
    },
  },
  create() {
    console.log(itemObj);
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.item-bg {
  width: 50px;
  /*margin-bottom: 10px;*/
  margin-right: 8px;
  .item-img {
    width: 50px;
    height: 50px;
    border-radius: 4px;
    background: #f8f8f8;
    position: relative;
    overflow: hidden;
    img {
      width: 50px;
      height: 50px;
      border-radius: 4px;
      object-fit: contain;
      border: 1px solid transparent;
    }
    .item-title {
      color: white;
      font-size: 12px;
      /* line-height: 2; */
      text-align: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      position: absolute;
      bottom: 0;
      right: 0;
      left: 0;
      height: 20px;
      background: rgba(0, 0, 0, 0.7);
    }
  }
}
.active {
  // border: 4px solid #1890ff;

  border: 3px #015c61 solid;
}
</style>